define.alias("shared/helpers/html-safe", "settings/helpers/html-safe");